module.exports = __webpack_public_path__ + "static/media/man_03.db828397.png";